import { Component, Input, SimpleChanges, OnChanges } from '@angular/core';
import { AtpService } from 'src/app/general-services/atp/atp.service';
import { AtpCallContext, AtpRequestItem, AtpResponseItem } from 'src/app/general-services/atp/atp-interfaces';

@Component({
  selector: 'app-atp-info',
  templateUrl: './atp-info.component.html',
  styleUrl: './atp-info.component.scss',
})
export class AtpInfoComponent implements OnChanges {
  // Call context (broadest first): which screen is asking (stats-only), then
  // the customer being serviced. businessCustomer defaults to false: the
  // safer consumer routing when the customer type is unknown.
  @Input() callSource: string = 'service-portal';
  @Input() customerNumber?: string;
  @Input() businessCustomer: boolean = false;
  @Input() quantity?: number | null;
  @Input() sku?: string;
  @Input() units?: string;

  isLoading: boolean = false;
  errorOccurred: boolean = false;
  atpResponseItem: AtpResponseItem | null = null;
  iconColor: string = 'primary-color';

  constructor(private service: AtpService) {}

  ngOnChanges(changes: SimpleChanges): void {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (changes.sku !== undefined && !changes.sku.firstChange) {
      this.reset();
    }
  }

  reset(): void {
    this.atpResponseItem = null;
    this.errorOccurred = false;
  }

  setIconColor(color: string): void {
    this.iconColor = color;
  }

  getAtpInfo() {
    this.isLoading = true;

    const quantity = this.quantity ?? 1;
    const sku = this.sku ?? '';

    const context: AtpCallContext = {
      callSource: this.callSource,
      customerNumber: this.customerNumber,
      businessCustomer: this.businessCustomer,
    };
    const requestItem: AtpRequestItem = {
      sku,
      quantity: quantity.toString(),
    };

    this.service.getSingleAtpInfo(context, requestItem).subscribe(
      (atpResponseItem: AtpResponseItem) => {
        this.atpResponseItem = atpResponseItem;
        this.errorOccurred = false;
        this.isLoading = false;
      },
      error => {
        console.error(error);
        this.errorOccurred = true;
        this.isLoading = false;
      }
    );
  }
}
